import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { IDigitealTechnicalUser } from "../types/digiteal/IDigiteal"
import { SharedStoreState } from "./SharedStoreState"

export interface IDigitealStoreAddition {
    digiteal: IDigitealSliceState
}

interface IDigitealSliceState {
    technicalUser: { [merchantId: string]: IDigitealTechnicalUser | undefined }
}

const initialState: IDigitealSliceState = {
    technicalUser: {},
}

export const digitealSlice = createSlice({
    name: "digiteal",
    initialState,
    reducers: {
        setTechnicalUser: (state, action: PayloadAction<{ merchantId: string; technicalUser: IDigitealTechnicalUser }>) => {
            state.technicalUser[action.payload.merchantId] = action.payload.technicalUser
        },
    },
})

export const digitealActions = digitealSlice.actions
export const digitealSelectors = {
    technicalUser: (state: SharedStoreState, merchantId: string) => state.digiteal.technicalUser[merchantId],
}
